// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store/store'
import notice from './components/common/notice'
import noticeconfirm from './components/common/noticeconfirm'

Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.component('notice', notice)
Vue.component('noticeconfirm', noticeconfirm)

Vue.prototype.$bus = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js